export default __webpack_public_path__ + "static/media/hht2_ep04_timeline_q01_a.cef2e020.png";